import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import Search from './Search';
import Edit from './Edit';
import Login from './Login';
import { backToSearchClicked } from '../actions/SearchActionCreators';
import { IntlProvider } from 'react-intl';
import FontAwesome from 'react-fontawesome';

@connectToStores(['LoginStore', 'MessageStore'], (context, props) => {
  const LoginStore = context.getStore('LoginStore');
  const MessageStore = context.getStore('MessageStore');

  return {
    selectedScreen: LoginStore.getSelectedScreen(),
    messages: MessageStore.getMessages(),
    locale: MessageStore.getLocale(),
    canEdit: LoginStore.canEdit()
  };
})
class Container extends Component {
  static propTypes = {
    selectedScreen: PropTypes.string.isRequired,
    messages: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    canEdit: PropTypes.bool.isRequired
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.backClicked = this.backClicked.bind(this);
  }

  backClicked() {
    this.context.executeAction(backToSearchClicked, {});
  }

  render() {
    const {
      selectedScreen,
      messages,
      locale,
      canEdit
    } = this.props;

    let FrameComponent = Search;
    const backButton = <button className="btn btn-link back" onClick={this.backClicked}><FontAwesome name="arrow-left" /></button>;
    let back;

    switch (selectedScreen) {
      case 'edit':
        FrameComponent = Edit;
        back = backButton;
        break;
      case 'login':
        FrameComponent = Login;
        back = backButton;
        break;
      default:
        break;
    }

    if (!canEdit) {
      back = undefined;
    }

    return <IntlProvider locale={locale} messages={messages}>
      <div className="form-container employee-login-container">
        {back}
        <FrameComponent />
      </div>
    </IntlProvider>;
  }
}

export default Container;



/** WEBPACK FOOTER **
 ** ./src/main/js/employeeLogin/components/Container.js
 **/